import React from 'react';
import UserListPage from './UserListPage';
import { USER_TYPES } from '../store/actions/userManagement';

const MiniAdminListPage = () => {
  return (
    <UserListPage 
      userType={USER_TYPES.MINIADMIN} 
      title="Mini Admin Details"
    />
  );
};

export default MiniAdminListPage;